export function vhHack() {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // for transform scale
  const range = 1 / 400;
  const scale = range * Math.min(window.innerWidth, window.innerHeight);
  document.documentElement.style.setProperty('--vh-scale', `${scale}`);
}
